import { AxiosResponse } from "axios";
import { StatusResponse } from "../../types/type";
import Api from "../api";
import { LOGIN, PASSWORDRESET } from "../endpoint";
import { RolesMaster } from "../../types/assetTypes";
export const login = async(payload:{email: string, password: string}): Promise<{
        status: StatusResponse, 
        data: {
            userId: number,
            email: string,
            roles: RolesMaster[],
            token: string,
            name: string,
            projectIds: number[]
        }
    }>  => {
    try{
        const response:AxiosResponse<{
            status: StatusResponse, 
            data: {
                userId: number,
                email: string,
                roles: RolesMaster[],
                token: string,
                name: string,
                 projectIds: number[]
            }
        }> = await Api.post(LOGIN,payload);        
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Login Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const passwordReset = async(payload:{email: string, oldPassword: string, newPassword: string}): Promise<{
        status: StatusResponse, 
        data: {
            
        }
    }>  => {
    try{
        const response:AxiosResponse<{
            status: StatusResponse, 
            data: {
               
            }
        }> = await Api.post(PASSWORDRESET,payload);        
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Login Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}